/**
 * Single ornamental gold corner flourish — placed at the 4 corners of a
 * Forecourt plaque to evoke gilded picture-frame trim. The shape is a
 * stylised lotus/scroll motif.
 */
export function FiligreeCorner({
  className,
  size = 36,
}: {
  className?: string;
  size?: number;
}): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      className={className}
      role="presentation"
      aria-hidden="true"
    >
      <g fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round">
        {/* L-shape border edge */}
        <path d="M 2 14 L 2 2 L 14 2" />
        {/* Outer flourish curl */}
        <path d="M 2 14 Q 8 14 10 10 Q 12 6 16 5 Q 20 4 22 8" />
        <path d="M 14 2 Q 14 8 10 10" />
        {/* Inner blossom */}
        <circle cx="10" cy="10" r="2" fill="currentColor" />
        <path d="M 6 18 Q 14 22 18 14" />
        <path d="M 18 14 Q 20 12 24 14 Q 22 18 18 14" fill="currentColor" />
        {/* Tassel tip */}
        <path d="M 26 5 L 30 3 M 26 5 L 28 8" />
      </g>
    </svg>
  );
}
